import CloseIcon from '@mui/icons-material/Close';
import {
  Box,
  Toolbar,
} from '@mui/material';
import { isEmpty } from 'lodash';
import React from 'react';
import { EmployeeEditRequestBody } from '../../../../state/ducks/auth/types';
import Text from '../../../components/Text';
import { Translation } from '../../../translations/types';
import { StyledAppBar, StyledIconButton, UserName, UserNameEdit, UserProfileTitle } from './styles';

const MAX_NAME_LENGTH = 100;

interface Props {
  close: () => void
  showEditUser: boolean
  name: string
  userInfo: EmployeeEditRequestBody
  setUserInfo: (values: EmployeeEditRequestBody) => void
  setUsernameError: (value: Translation | null) => void
  usernameError: Translation | null
}

const DialogTitle: React.FC<Props> = ({
  close,
  showEditUser,
  name,
  userInfo,
  setUserInfo,
  setUsernameError,
  usernameError,
}) => {
  const handleNameChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    const value = event.target.value;

    if (isEmpty(value)) {
      return setUsernameError('validator.user.name.required');
    }

    if (value.length > MAX_NAME_LENGTH) {
      return setUsernameError('validator.user.name.length');
    }

    setUserInfo({ ...userInfo, name: value });
    setUsernameError(null);
  };

  const userNameRenderer = (name: string) => (
    <UserName variant="h3" id="DialogTitle-name">
      {name}
    </UserName>
  );

  const editUserNameRenderer = (name: string) => (
    <UserNameEdit
      error={Boolean(usernameError)}
      defaultValue={name}
      onChange={handleNameChange}
      id="DialogTitle-nameEdit"
      helperText={usernameError && <Text translation={usernameError} />}
      variant="standard"
    />
  );

  return (
    <StyledAppBar>
      <Toolbar>
        <StyledIconButton
          onClick={close}
          aria-label="Close"
          id="DialogContent-close"
          size="large"
        >
          <CloseIcon />
        </StyledIconButton>
      </Toolbar>
      <Box display="block" textAlign="center">
        <UserProfileTitle variant="h4">
          <Text translation="user.management.profile" />
        </UserProfileTitle>
        {!showEditUser && userNameRenderer(name)}
        {showEditUser && editUserNameRenderer(name)}
      </Box>
    </StyledAppBar>
  );
};

export default DialogTitle;
